import {Layout} from 'antd';
import React from 'react';
import {Outlet, useLocation} from 'react-router-dom';
import HeaderRight from '../components/HeaderRight';
import RouteList from "./routeList";
import Logo from '../assets/mertech-logo.png';

const {Header, Content, Footer} = Layout;

function Main() {

    const location = useLocation();

    return (
        <Layout className="layout-container">
            <Header className="site-layout-background header">
                <div className="logo">
                    <img src={Logo} alt="Logo" className="logo-image"/>
                </div>
                <RouteList/>
                <HeaderRight/>
            </Header>
            <Content
                className={
                    location.pathname === '/'
                        ? 'site-layout-background'
                        : 'site-layout-content site-layout-background'
                }
            >
                <Outlet/>
            </Content>
            <Footer
                style={{
                    textAlign: 'center',
                    display: "flex",
                    alignItems: 'center',
                    alignContent: 'center',
                    justifyContent: 'center'
                }}
            >
                Mertech Cocpit ©2024 <br/> MERTECH ELEKTRONİK ARGE SANAYİ VE TİCARET A.Ş.
                <div style={{
                    width: 44,
                    padding: 4,
                    height: 'auto',
                    color: 'white',
                    fontSize: 14,
                    fontWeight: '500',
                    alignContent: 'center',
                    alignItems: 'center',
                    justifyContent: "center",
                    backgroundColor: '#1677FF',
                    border: '1px solid lightgray',
                    borderRadius: 4
                }}> BETA</div>
            </Footer>
        </Layout>
    );
}

export default Main;
